import React, { useEffect, useState } from 'react';
import BasicInfo from './BasicInfoForm';
import QualificationForm from './QualificationForm';
import BankDetailsForm from './BankDetailsForm';
import NomineeDetailsForm from './NomineeDetailsForm';
import '../../../Assets/Css/PospRegistration.css'
import { Card } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import apiUrls from '../../../Api/MainApi';
import Swal from 'sweetalert2';

import "./index.css"
import Loader from '../../../Layout/Loader/Loader';
import { useNavigate } from 'react-router-dom';

const PospRegistrationComp = () => {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate()
    const [isNextDisabled, setIsNextDisabled] = useState(false);
    const [loading, setloading] = useState(false);
    const [pospid, setPospid] = useState(0);
    const [formData, setFormData] = useState({
        Fname: "",
        Lname: "",
        DOB: null,
        Gender: null,
        MobileNo: "",
        EmailID: "",
        Address: "",
        State: null,
        City: null,
        Pincode: null,
        AccountHolderName: "",
        AccountNo: "",
        IFSCCode: "",
        BankName: null,
        CancelledCheque: "",
        NomineeName: "",
        RelationShip: null,
        NomineeDOB: "",
        NomineeAddress: "",
        AgreeToTerms: false,
        ProfilePic: "",
        Course: null,
        InstituteName: "",
        PassingYear: "",
        Document: "",
        AddharNo: "",
        AddharFile: "",
        PANNO: "",
        PANFILE: "",
        isTaxPayer: true,
        TaxCode: "",
        FYYear: "",
        TaxDoc: "",
        modifiedBy: 1,
        isActive: true
        
    });
    const [isFormValid, setIsFormValid] = useState(false);

    const handleNextClick = () => {
        if (!isFormValid) {
            toast.error("Please fill out all required fields correctly.");
            return;
        }
    };

    console.log(formData)
    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    useEffect(() => {
        setPospid(sessionStorage.getItem('pospid'));
        const id = sessionStorage.getItem('pospid')
        setFormData(prevData => ({ ...prevData, POSPID:id }));
    }, []);

    const handleFileChange = (file, field) => {
        if (file instanceof File) {
            convertFileToBase64(file)
                .then((result) => setFormData(prevData => ({ ...prevData, [field]: result })))
                .catch((error) => console.error(`Error converting ${field}:`, error));
        }
    };

    useEffect(() => {
        handleFileChange(formData.Document, 'Document');
    }, [formData.Document]);

    useEffect(() => {
        handleFileChange(formData.ProfilePic, 'ProfilePic');
    }, [formData.ProfilePic]);

    useEffect(() => {
        handleFileChange(formData.TaxDoc, 'TaxDoc');
    }, [formData.TaxDoc]);

    useEffect(() => {
        handleFileChange(formData.AddharFile, 'AddharFile');
    }, [formData.AddharFile]);

    useEffect(() => {
        handleFileChange(formData.PANFILE, 'PANFILE');
    }, [formData.PANFILE]);

    useEffect(() => {
        handleFileChange(formData.CancelledCheque, 'CancelledCheque');
    }, [formData.CancelledCheque]);

    useEffect(() => {
        const isStepValid = (step) => {
            switch (step) {
                case 0:
                    return (
                        formData.Fname &&
                        formData.Lname &&
                        formData.MobileNo &&
                        formData.State &&
                        formData.City &&
                        formData.DOB &&
                        formData.EmailID &&
                        formData.Pincode &&
                        formData.Gender &&
                        formData.Address
                    );
                case 1:
                    return (
                        formData.ProfilePic &&
                        formData.Course &&
                        formData.InstituteName &&
                        formData.PassingYear &&
                        formData.Document &&
                        formData.AddharNo &&
                        formData.PANFILE &&
                        formData.AddharFile &&
                        formData.PANNO &&
                        (formData.isTaxPayer == false) ||
                        formData.TaxCode &&
                        formData.FYYear &&
                        formData.TaxDoc
                    );
                case 2:
                    return (
                        formData.AccountHolderName &&
                        formData.AccountNo &&
                        formData.IFSCCode &&
                        formData.BankName &&
                        formData.CancelledCheque
                    );
                case 3:
                    return (
                        formData.NomineeName &&
                        formData.RelationShip &&
                        formData.NomineeDOB &&
                        formData.NomineeAddress
                    );
                default:
                    return false;
            }
        };
        setIsNextDisabled(!isStepValid(currentStep));
    }, [formData, currentStep]);

    const handleNextButtonClick = () => {
        if (!isFormValid) {
            toast.error("Please fill valid Data.");
            return;
        } else {
            if (isNextDisabled) {
                toast.error('Please enter the valid data.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setCurrentStep((prevStep) => prevStep + 1);
            }
        }
    };

    const handlePrevButtonClick = () => {
        setCurrentStep((prevStep) => prevStep - 1);
    };

    const handleSubmit = () => {
        if (!isFormValid) {
            toast.error("Please fill valid Data.");
            return;
        } else {
            if (isNextDisabled) {
                toast.error('Please enter the valid data.', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                const FormsData = {
                    POSPID:formData.POSPID,
                    Fname:formData.Fname ,
                    Lname: formData.Lname ,
                    MobileNo: formData.MobileNo ,
                    Pincode:formData.Pincode,
                    EmailID:formData.EmailID,
                    AdditionalJson:JSON.stringify(formData),
                    modifiedBy: 1,
                    isActive: true,
                }
                console.log("FormsDataFormsDataFormsDataFormsData",FormsData)
                setloading(true)
                axios.post(apiUrls.UpdatePOSPRequestMaster, FormsData)
                    .then(response => {
                        console.log(response)
                        if (response.data.responseStatusCode === 1) {
                            toast.success(response.data.message, {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });

                            Swal.fire({
                                title: "Thank you for registering with us!",
                                text: "We are currently processing your account verification, and this may take up to 2-3 business days. Once the verification process is complete, you will receive a confirmation email.",
                                icon: "info",
                                confirmButtonText: "OK"
                            }).then(() => {
                                navigate(`${process.env.PUBLIC_URL}/`);
                                setloading(false);
                            });
                        } else {
                            toast.error('There was an error with your submission.', {
                                position: "top-right",
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    setloading(false)
                                    navigate(`${process.env.PUBLIC_URL}/posp/registration`);
                                }
                            });
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        setloading(false)
                        toast.error('An error occurred while submitting the data.', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });

                    });
            }
        }
    };


    const PageDisplay = () => {
        switch (currentStep) {
            case 0:
                return <BasicInfo formData={formData} setFormData={setFormData} setIsFormValid={setIsFormValid} />;
            case 1:
                return <QualificationForm formData={formData} setFormData={setFormData} setIsFormValid={setIsFormValid} />;
            case 2:
                return <BankDetailsForm formData={formData} setFormData={setFormData} setIsFormValid={setIsFormValid} />;
            case 3:
                return <NomineeDetailsForm formData={formData} setFormData={setFormData} setIsFormValid={setIsFormValid} />;
            default:
                return null;
        }
    };

    const FormTitles = ["Basic Information", "Qualification", "Bank Details", "Nominee Details"];
    const totalPages = FormTitles.length;
    const progressWidth = ((currentStep + 1) / totalPages) * 100 + "%";

    return (
        <>
            <div className='main-form'>
                <div className="progressbar mt-5">
                    <div style={{ width: progressWidth }}></div>
                </div>
                <Card className='posp-regestration-card-form mb-5'>
                    
                    {(loading) ? <Loader /> : PageDisplay()}
                    <div className='d-flex justify-content-center gap-5'>
                        <div className='button-container mx-5'>
                       {loading?"": 
                       <button
                            className='posp-back-button'
                            hidden={currentStep === 0}
                            onClick={handlePrevButtonClick}
                        >
                            <svg height="16" width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 1024 1024">
                                <path d="M874.690416 495.52477c0 11.2973-9.168824 20.466124-20.466124 20.466124l-604.773963 0 188.083679 188.083679c7.992021 7.992021 7.992021 20.947078 0 28.939099-4.001127 3.990894-9.240455 5.996574-14.46955 5.996574-5.239328 0-10.478655-1.995447-14.479783-5.996574l-223.00912-223.00912c-3.837398-3.837398-5.996574-9.046027-5.996574-14.46955 0-5.433756 2.159176-10.632151 5.996574-14.46955l223.019353-223.029586c7.992021-7.992021 20.957311-7.992021 28.949332 0 7.992021 8.002254 7.992021 20.957311 0 28.949332l-188.073446 188.073446 604.753497 0C865.521592 475.058646 874.690416 484.217237 874.690416 495.52477z"></path>
                            </svg>
                            <span style={{ color: 'black' }}>Back</span>
                        </button>}

                        {currentStep === FormTitles.length - 1 ? (
                        (loading ?"":<button className='posp-next-button'  onClick={handleSubmit}>Submit</button>)  
                        ) : (
                            (loading ? "":<button className='posp-next-button' onClick={handleNextButtonClick}>Next</button>)  
                           
                        )}
                        </div>
                    </div>
                </Card>
            </div>
            <ToastContainer />
        </>
    );
};

export default PospRegistrationComp;
